export default {"src":"/_next/static/media/step-send.bf9e1a0e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};